// Simple auth-screens shell — a centered card on a soft cream background
// that matches the marketing site's palette. Kept in one file because all
// four auth screens share the exact same wrapper; only the inner form
// differs.
import { Link } from "react-router-dom";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-[calc(100vh-80px)] w-full flex items-center justify-center px-4 py-16"
         style={{ background: "var(--surface, #F5F1E8)" }}>
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8" data-testid="auth-brand">
          <img src="/assets/brand/logo-header.png" alt="" className="w-10 h-10 object-contain" />
          <span className="font-extrabold tracking-[0.12em] text-[15px]" style={{ color: "var(--brand)" }}>
            MYADVENTURE-PASSPORT
          </span>
        </Link>
        <div className="card-elev p-8 md:p-10">
          <h1 className="text-2xl md:text-3xl font-extrabold mb-2"
              style={{ color: "var(--brand)" }} data-testid="auth-title">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm mb-8" style={{ color: "var(--on-surface-muted)" }}>
              {subtitle}
            </p>
          )}
          {children}
        </div>
        {footer && (
          <div className="text-center mt-6 text-sm" style={{ color: "var(--on-surface-muted)" }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
